import React from "react";

interface RefreshIconProps {
  className?: string;
}

const RefreshIcon: React.FC<RefreshIconProps> = ({ className = "w-4 h-4" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <mask
      id="mask0_2438_976"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2438_976)">
      <path
        d="M9.99984 16C8.33317 16 6.90609 15.4097 5.71859 14.2292C4.53109 13.0486 3.95817 11.5972 3.99984 9.875L3.33317 10.5417C3.18039 10.6944 3.00331 10.7708 2.80192 10.7708C2.60053 10.7708 2.42345 10.6944 2.27067 10.5417C2.11789 10.3889 2.0415 10.2118 2.0415 10.0104C2.0415 9.80903 2.11789 9.63194 2.27067 9.47917L4.229 7.52083C4.38178 7.36806 4.55539 7.29167 4.74984 7.29167C4.94428 7.29167 5.11789 7.36806 5.27067 7.52083L7.229 9.47917C7.38178 9.63194 7.45817 9.80556 7.45817 10C7.45817 10.1944 7.38178 10.3681 7.229 10.5208C7.07623 10.6736 6.89914 10.75 6.69775 10.75C6.49637 10.75 6.31928 10.6736 6.1665 10.5208L5.49984 9.875C5.47206 11.1806 5.90262 12.2778 6.7915 13.1667C7.68039 14.0556 8.74984 14.5 9.99984 14.5C10.1665 14.5 10.3332 14.4896 10.4998 14.4688C10.6665 14.4479 10.8262 14.4236 10.979 14.3958C11.1873 14.3542 11.3853 14.3715 11.5728 14.4479C11.7603 14.5243 11.8957 14.6597 11.979 14.8542C12.0623 15.0486 12.0589 15.2361 11.9686 15.4167C11.8783 15.5972 11.7359 15.7153 11.5415 15.7708C11.2915 15.8403 11.0415 15.8958 10.7915 15.9375C10.5415 15.9792 10.2776 16 9.99984 16ZM9.99984 5.5C9.83317 5.5 9.6665 5.51042 9.49984 5.53125C9.33317 5.55208 9.17345 5.57639 9.02067 5.60417C8.81234 5.64583 8.61442 5.62847 8.42692 5.55208C8.23942 5.47569 8.11095 5.34028 8.0415 5.14583C7.97206 4.95139 7.97553 4.76389 8.05192 4.58333C8.12831 4.40278 8.26373 4.28472 8.45817 4.22917C8.70817 4.15972 8.96164 4.10417 9.21859 4.0625C9.47553 4.02083 9.73595 4 9.99984 4C11.6804 4 13.1109 4.59028 14.2915 5.77083C15.4721 6.95139 16.0415 8.40278 15.9998 10.125L16.6665 9.45833C16.8193 9.30556 16.9964 9.22917 17.1978 9.22917C17.3991 9.22917 17.5762 9.30556 17.729 9.45833C17.8818 9.61111 17.9582 9.78819 17.9582 9.98958C17.9582 10.191 17.8818 10.3681 17.729 10.5208L15.7707 12.4792C15.6179 12.6319 15.4443 12.7083 15.2498 12.7083C15.0554 12.7083 14.8818 12.6319 14.729 12.4792L12.7707 10.5208C12.6179 10.3681 12.545 10.191 12.5519 9.98958C12.5589 9.78819 12.6387 9.61111 12.7915 9.45833C12.9443 9.30556 13.1214 9.22917 13.3228 9.22917C13.5241 9.22917 13.7012 9.30556 13.854 9.45833L14.4998 10.125C14.5276 8.81944 14.0971 7.72222 13.2082 6.83333C12.3193 5.94444 11.2498 5.5 9.99984 5.5Z"
        fill="#2D2D2D"
      />
    </g>
  </svg>
);

export default RefreshIcon;
